import(/* webpackMode: "eager" */ "/app/app/[locale]/auth/signup/page.tsx");
